import { PropsWithChildren, useLayoutEffect } from "react"
import { RouteComponentProps } from "@reach/router"

export const OverflowBaseElementId = `OVERFLOWED_BASE_ELEMENT_ID`

export const ScrollToTop = (props: PropsWithChildren<RouteComponentProps>) => {
  const { location, children } = props
  useLayoutEffect(() => {
    document.getElementById(OverflowBaseElementId)?.scrollTo(0, 0)
  }, [location?.pathname])
  return <>{children}</>
}
